import type { MetaUser } from "@grafana/faro-web-sdk";

import { getFaro } from "./faro";

export function setFaroUser(user: MetaUser): void {
  getFaro()?.api.setUser(user);
}
